define(["marionette", "messaging/messenger", "./showTokenModalView"], function (
  Marionette,
  Messenger,
  ShowTokenModalView,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "userAdminShowTokenModal";
      this.region = options.region;
    },
    show: function (refreshToken) {
      this.view = new ShowTokenModalView.view({
        model: refreshToken,
      });
      this.view.on("done", () => Messenger.vent.trigger("close:modal"));
      this.showRegion(this.view);
    },
  });
});
